export const CHARTS = [
  {
    title: 'financialAnalysis.EQUITY_TO_ASSETS',
    dataKey: 'RT0248',
    color: '#006AA6',
  },
  { title: 'financialAnalysis.CAR', dataKey: 'NB219', color: '#F49966' },
  {
    title: 'financialAnalysis.EQUITY_TIER1',
    dataKey: 'FA060',
    color: '#74B49A',
  },
]
